// extracted by mini-css-extract-plugin
export default {"fs":"_8449b43814 _8bfe500858"};